
import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';

export const qualityComissionService = {
  getAll,
  createOrUpdate,
  deleteMember
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL}/api/quality_boards/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function createOrUpdate(newMember) {
  const requestOptions = {
    method: newMember.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newMember)
  };

  let authentication = new AuthenticationService();

  console.log(authentication.loggedIn());

  if (authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/quality_boards${
    newMember.id ? `/${newMember.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}
function createBodyRequest(member) {
  let formData = new FormData();

  formData.append('quality_board[name]', member.name);
  formData.append('quality_board[position]', member.position);
  const document = member.document;

  if (document) {
    if (document.url) {
      formData.append(`quality_board[document]`, document.url);
    } else {
      formData.append(`quality_board[document]`, document, document.name);
    }
  }
  const documentDecision = member.documentDecision;
  if (documentDecision) {
    if (documentDecision.url) {
      formData.append(`quality_board[document_decision]`, documentDecision.url);
    } else {
      formData.append(`quality_board[document_decision]`, documentDecision, documentDecision.name);
    }
  }

  return formData;
}
function deleteMember(memberId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/quality_boards/${memberId}`;

  return axios.delete(url, requestOptionsDelete);
}
